import React from "react";
import Alert from '../../photos/Alert.png'


const DeleteModal = ({closeDeleteModal,showDeleteModal,RemoveItem,text,title,logout}) => {
  return (
    <>
      
      {showDeleteModal ? (
        <>
          <div className="bg-bg-blur justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-xs-1 bg-main-red rounded-sm">
              {/*content*/}
              <div className="mt-1.5 border-0  shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
              <div className="w-9.5 h-9.5 m-auto mt-10.1"> <img className="w-full h-full object-cover" src={Alert}/></div>
                {/*body*/}
                <div className="flex justify-center flex-col items-center p-5.5 flex-auto pb-0">
                  <p className="text-16 font-medium text-dark-blue-200">{title}</p>
                  <p className="text-14 text-center font-normal text-dark-blue-200 mt-2.5">{text}</p>
                </div>
                {/*footer*/}
                <div className="flex items-center justify-between gap-3.6 p-5.5 mt-10.1 pt-0 ">
                  <button
                    className="bg-btn-gray  font-medium text-dark-blue-200 text-12 py-2.5 text-sm outline-none focus:outline-none  w-132.5"
                    type="button"
                    onClick={closeDeleteModal}>
                    خیر، بازگشت
                  </button>
                  <button
                    className="bg-main-red font-medium text-white text-12 py-2.5 text-sm outline-none focus:outline-none  w-132.5"
                    type="button"
                    onClick={RemoveItem}>
                  {logout===true?"بله، خروج":"بله، حذف"} 
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          
        </>
      ) : null}
    </>
  );
};

export default DeleteModal;
